import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {
  RegroupementPlatService
} from "../../../../core/services/conditionnements/regroupement/regroupement-plat.service";
import {
  ErreurParametrageRegroupementPlatMl
} from "../../../../core/models/gestion-conditionnements/regroupement/plat/erreur-parametrage-regroupement-plat-ml";

@Component({
  selector: 'yo-regroupement-plat-errors',
  templateUrl: './regroupement-plat-errors.component.html',
  styleUrls: ['./regroupement-plat-errors.component.scss']
})

export class RegroupementPlatErrorsComponent implements OnInit, OnDestroy {

  displayDialog: boolean;

  constructor(private utilSvc: UtilsService,
              private regroupementPlatSvc: RegroupementPlatService) {}

  private subOpenDialog: Subscription;

   errors: ErreurParametrageRegroupementPlatMl[];

  ngOnInit() {
    this.initSubOpenDialog();
  }


  ngOnDestroy() {
    this.utilSvc.unsubscribe(this.subOpenDialog);
  }

  private initSubOpenDialog() {
    this.subOpenDialog = this.regroupementPlatSvc.subjectRegroupementErrors$.subscribe((res) => {
      console.log("erreurs")
      if (res)
        this.errors = res
      this.displayDialog = true;
    });
  }

  closeDialog() { this.displayDialog = false;}

}
